$(document).ready(function() {
	
	var days = 180;
	var dataRGPD = JSON.parse(document.getElementById('data-wadrgpd').innerHTML);
	
	var state = dataRGPD.state;
	//console.log(dataRGPD);
	
	// Accept All Cookie
	$('body').on('click', '.wad-accept-cookie', function(){
		$('.wad-reject-cookie').removeClass('disabled');
		$('.wad-accept-cookie').addClass('disabled');
		hideCookieBanner();
		
		//Il faut mettre tous les cookies à true;
		for(let variable in state) {
			state[variable] = true;
		}
		
		//console.log(state);
		
		//On set le cookie
		createCookie('wad-cookie-consent',JSON.stringify(state),days);
		
		//Il faut lancer les scripts qui sont à true
		getScripts(dataRGPD.list,state);
	});
	
	// Reject All Cookie
	$('body').on('click', '.wad-reject-cookie', function(){
		$('.wad-reject-cookie').addClass('disabled');
		$('.wad-accept-cookie').removeClass('disabled');
		hideCookieBanner();
		//Il faut mettre tous les cookies à false;
		for(let variable in state) {
			state[variable] = false;
		}
		//On set le cookie
		createCookie('wad-cookie-consent',JSON.stringify(state),days);
	});
	
	// Save preferences Cookie
	$('body').on('click', '.wad-save-cookie', function(){
		state.answer = true;
		createCookie('wad-cookie-consent',JSON.stringify(state),days);
		hideCookieBanner();
		getScripts(dataRGPD.list,state);
	});
	
	//Accept One Cookie
	$('body').on('click', '.wad-state-cookie', function(){
		cookieName = $(this).data('name');
		value = $(this).prop('checked');
		
		state[cookieName] = value;
	});
	
	if (window.doNotTrack || navigator.doNotTrack || navigator.msDoNotTrack || ('external' in window && 'msTrackingProtectionEnabled' in window.external)) {
	    // The browser supports Do Not Track!
		if (window.doNotTrack == "1" || window.doNotTrack == 1 || navigator.doNotTrack == "yes" || navigator.doNotTrack == "1" || navigator.msDoNotTrack == "1" || ('external' in window && 'msTrackingProtectionEnabled' in window.external && window.external.msTrackingProtectionEnabled())) {
	    	hideCookieBanner();
	    	//showDnTBanner();
	    	return;
	    } 
	} 
	
	var consentCookie = readCookie('wad-cookie-consent');
	if(consentCookie == null) {
		showCookieBanner();
	} else {
		hideCookieBanner();
		var consentObject = JSON.parse(consentCookie);
		if(consentObject.answer == 1) {
			//Lancer les scripts qui sont à true
			getScripts(dataRGPD.list,state);
		}
	}
});

function getScripts(list,state) {
	for(let cptScript in list) {
		if(state[list[cptScript].name]==true) {
			for(let srcScript in list[cptScript].scripts) {
				$.getScript(list[cptScript].scripts[srcScript], function( data, textStatus, jqxhr ) {
					
				});
			}
		}
	}
}

function showCookieBanner() {
	$('.wad-banner-cookie').removeClass('d-none hidden');
}

function hideCookieBanner() {
	$('.wad-banner-cookie').addClass('d-none hidden');
}

function showDnTBanner() {
	$('.wad-banner-do-not-track').removeClass('d-none hidden');
}

//https://www.quirksmode.org/js/cookies.html
function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	} else {
		var expires = "";
	} 
		
	document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') {
			c = c.substring(1,c.length);
		}
		if (c.indexOf(nameEQ) == 0) {
			return c.substring(nameEQ.length,c.length);
		}
	}
	return null;
}
